import React, { useEffect, useState} from 'react'
import '../stylesheets/dashboard.scss';
import { useUserProfile } from '../helper/UserProfile'

function DashboardMain() {
    
    const { profile, loading } = useUserProfile();
    
    if (loading) return;
    if (!profile) return <div>No profile found.</div>;


    return (
    <div className="dashboard-body">
      <h1>{profile.first_name === "" || !profile.first_name ? "WELCOME, NEWCOMER" : <>WELCOME, <span style={{textTransform: "uppercase"}}>{profile.first_name}</span></>}</h1>
      <p>{profile.first_name === "" || !profile.first_name ? "Please complete your profile." : ""}</p>
      <p>Thank you for using the <span style={{fontFamily: "Garet Extra Bold"}}>1664 Training Solutions</span> Practitioner Portal. Please bear with us while we continue to develop this platform.</p>
      <p>New features coming soon!</p>
    </div>
  )
}

export default DashboardMain